'use client'
import React, { useEffect, useRef } from "react";
import zigzag from './../../assets/zig-zag.png'
import Image from "next/image";

export default function ServiceArea({ our_service_areas, service_map }) {
  
  const contentRef = useRef(null);

  useEffect(() => {
    const container = contentRef.current;

    const handleLinkClick = (e) => {
      const link = e.target.closest('a[data-link]');
      if (link) {
        e.preventDefault(); // Prevent the default anchor behavior
        const url = link.getAttribute('data-link');
        if (url) {
          window.open(url, '_blank', 'noopener,noreferrer');
        }
      }
    };

    container.addEventListener('click', handleLinkClick);

    return () => container.removeEventListener('click', handleLinkClick);
  }, []);


  return (
    <div className="container mx-auto py-20">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
                        <h2 className='text-5xl font-semibold text-brand text-center mb-4 mt-4 leading-normal font-jost'>Our Service Areas
</h2>
                  <Image src={zigzag} width={80} height={17} alt="zig" className='mb-6 mx-auto' />        
        
          <div className="text-lg mb-5" ref={contentRef} dangerouslySetInnerHTML={{ __html: our_service_areas }}></div>
        </div>
        <div>
        {service_map &&
          <iframe src={service_map} className="w-full h-full" />
        }
        </div>
      </div>
    </div>
  );
}
